import React from 'react';
import Logo from "../../../../assets/images/LogoNew.svg";
import BusinessContent from './BusinessContent';
import "./styles.scss";

const ApplyBusinessLiteContent = () => {


    return (
        <div>
            <div className="form-content-container xl px-2 px-sm-3">
                <div className='form-content-header'>
                    <img
                        src={Logo}
                        alt={("fv-bank")}
                        className="logo logo-dark form-content-logo"
                    />
                </div>
                <BusinessContent />
            </div>
        </div>
    );
};

export default ApplyBusinessLiteContent;
